import Select from '@components/v2/form/Select/Select';
import { SelectOptionValue } from '@components/v2/form/Select/select.types';
import MenuItem from '@components/v2/ui/Menu/MenuItem';
import { SelectChangeEvent } from '@mui/material';
import LangEnum from '../../../../../lang/LangEnum';
import { useTranslation } from '../../../../translation/TranslationContext';
import SettingContainer from '../../../SettingContainer';
import { ObservationSectionGeneralSettingsProps } from '../../types/GeneralSettings.types';
import {
  mapRolesToHideOrderObservationFromBackend,
  mapRolesToHideOrderObservationToBackend,
  orderObservationRolesOptions,
} from './observationSectionGeneralSettings.utils';

const ObservationSectionGeneralSettings = ({
  generalSettings,
  handleChangeAndBlur,
}: ObservationSectionGeneralSettingsProps) => {
  const { translate } = useTranslation();

  const selectedValues = generalSettings.rolesToHideOrderObservation
    ? mapRolesToHideOrderObservationFromBackend(generalSettings.rolesToHideOrderObservation)
    : [];

  const changeRoles = (values: string[]) =>
    handleChangeAndBlur({
      name: 'rolesToHideOrderObservation',
      value: mapRolesToHideOrderObservationToBackend(values),
    });

  const handleChangeRoles = (event: SelectChangeEvent<unknown>) =>
    changeRoles(event.target.value as string[]);

  const handleDeleteRole = (deletedValue: SelectOptionValue) =>
    changeRoles(selectedValues.filter((value) => value !== deletedValue));

  return (
    <SettingContainer
      title={translate(LangEnum.ORDER_CONDITIONS_OBSERVATION_LABEL)}
      description={LangEnum.GENERAL_SETTINGS_HIDE_OBSERVATION_MESSAGE}
    >
      <Select
        multiple
        label={translate(LangEnum.GENERAL_SETTINGS_ROLES_HIDE_OBSERVATION_LABEL)}
        name="rolesToHideOrderObservation"
        value={selectedValues}
        multipleProps={{
          onDelete: handleDeleteRole,
          getChipConfig: (value) => ({
            label: translate(
              orderObservationRolesOptions.find((option) => option.value === value)!.label,
            ),
          }),
        }}
        onChange={handleChangeRoles}
      >
        {orderObservationRolesOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {translate(option.label)}
          </MenuItem>
        ))}
      </Select>
    </SettingContainer>
  );
};

export default ObservationSectionGeneralSettings;
